import { motion } from "framer-motion";
import { WHAT_WE_NEGOTIATE } from "@/data/content";
import { SectionEyebrow } from "@/components/Marquee";

export default function WhatWeNegotiate() {
  return (
    <section id="what-we-negotiate" className="relative py-20 md:py-28 bg-void" data-testid="what-we-negotiate-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <SectionEyebrow n="Ch. V" testId="what-we-negotiate-eyebrow">The Full Negotiation</SectionEyebrow>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.8, 0, 0.2, 1] }}
          className="mt-6 font-serif text-white text-5xl sm:text-6xl md:text-7xl leading-[0.98] tracking-tight max-w-4xl"
        >
          We don't negotiate one number. <span className="italic gradient-text">We negotiate the deal.</span>
        </motion.h2>

        <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {WHAT_WE_NEGOTIATE.map((w, i) => (
            <motion.div
              key={w.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.06 }}
              className={`relative rounded-3xl border p-7 md:p-8 ${
                i === WHAT_WE_NEGOTIATE.length - 1
                  ? "gradient-border bg-[#141323]"
                  : "border-white/5 bg-surface"
              }`}
              data-testid={`negotiate-card-${i}`}
            >
              <h3 className="font-serif text-xl md:text-2xl text-white leading-tight">{w.title}</h3>
              <p className="mt-3 text-sm text-silver/65 leading-relaxed">{w.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
